<template>
  <div id="app">

    <nav class="navbar sticky-top flex-md-nowrap p-0">
      <div v-on:click="toggle" class="navbar-brand mr-0" href="#">
        <menu-icon size="1.5x"></menu-icon>
        <!-- <x-icon size="1.5x" v-show="!menu_icon"></x-icon> -->
      </div>


      <!-- <ul class="navbar-nav px-3" style="margin-right: 15px">
        <li class="nav-item text-nowrap">
          <b-dropdown dropleft no-caret variant="none">
            <template v-slot:button-content>
              <div style="display: flex; padding-right:0">
                <div style="flex: 2;" class="text-right">
                  <h6 style="margin: 0;">Username</h6>
                  <small style="margin: 0">Account Settings</small>
                </div>

                <div class="text-right flex-right">
                  <user-icon size="1.5x" class="icon user-icon"></user-icon>
                </div>
              </div>

              Logout <span><log-out-icon size="1x"></log-out-icon></span>


            </template>

            <b-dropdown-item href="/">Logout</b-dropdown-item>
          </b-dropdown>
        </li>
        <li class="nav-item text-nowrap">
          <router-link to="/" class="logout">
            Logout <span><log-out-icon size="1x"></log-out-icon></span>
          </router-link>
        </li>
      </ul> -->
    </nav>

    <div class="container-fluid">
      <div class="row">
        <nav id="sidebar-menu" class="col-md-2 bg-light sidebar">
          <div class="sidebar-sticky">
            <ul class="nav">
              <router-link to="/home" id="home_icon">
                <li class="nav-item" style="margin-top: 60px" v-on:click="toggle">
                  <a class="nav-link" href="#">
                    <home-icon size="1.5x" ></home-icon>
                    <small>Home</small>
                  </a>
                </li>
              </router-link>
              <router-link to="/modulos">
                <li class="nav-item" v-on:click="toggle">
                  <a class="nav-link" href="#">
                      <layers-icon size="1.5x"></layers-icon>
                      <small>Modulos</small>
                  </a>
                </li>
              </router-link>
              <router-link to="/dashboard">
                <li class="nav-item" v-on:click="toggle">
                  <a class="nav-link" href="#">
                      <bar-chart-2-icon size="1.5x"></bar-chart-2-icon>
                      <small>Relatorio</small>
                  </a>
                </li>
              </router-link>
              <router-link to="/contact">
                <li class="nav-item" v-on:click="toggle">
                  <a class="nav-link" href="#">
                      <mail-icon size="1.5x"></mail-icon>
                      <small>Contato</small>
                  </a>
                </li>
              </router-link>
              <router-link to="/">
                <li class="nav-item" v-on:click="toggle">
                  <a class="nav-link" href="#">
                      <log-out-icon size="1.5x"></log-out-icon>
                      <small>Sair</small>
                  </a>
                </li>
              </router-link>
            </ul>
          </div>
        </nav>

        <main role="main" class="col-md-11 col-lg-11 pt-3 px-4 ml-diff" style="padding: 0!important">
          <b-container fluid >
            <b-row>
              <b-col style="padding-bottom: 50px">
                  <router-view></router-view>
              </b-col>
            </b-row>
          </b-container>
        </main>
      </div>
    </div>

    <router-link to="/contact">
      <div class="qna">
        <mail-icon></mail-icon>
      </div>
    </router-link>

  </div>
</template>

<script>
import {
  MenuIcon,
  HomeIcon,
  // XIcon,
  LogOutIcon,
  BarChart2Icon,
  LayersIcon,
  // UsersIcon,
  MailIcon
} from "vue-feather-icons";
// import Login from "./views/Login";
// import Modulos from "./components/Modulos.vue";
export default {
  data() {
    return {
      menu_icon: true
    };
  },
  components: {
    // Login,
    MenuIcon,
    HomeIcon,
    // XIcon,
    LogOutIcon,
    BarChart2Icon,
    LayersIcon,
    // UsersIcon,
    MailIcon
  },
  methods: {
    toggle: function() {
      var element = document.getElementById("sidebar-menu");
      element.classList.toggle("mySidebar");
      this.menu_icon = !this.menu_icon;
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Cinzel|Livvic&display=swap");
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-family: "Livvic", sans-serif;
}

.qna {
  position: fixed;
  text-align: center;
  bottom: 20px;
  right: 20px;
  background-image: linear-gradient(
    141deg,
    #2cb5e8 10%,
    #1fc8db 25%,
    #41ce8e 75%
  );
  border-radius: 100%;
  width: 60px;
  height: 60px;
}
.qna .feather {
  margin-top: 13px;
  width: 35px;
  height: 35px;
  color: #2c3e50;
  transition: .5s;
}
.qna:hover .feather {
  transition: .5s;
  color:#00060873;
}
.logout {
  color: #2c3e50;
  text-decoration-line: none;
  transition: .5s;
}
.logout:hover {
  color: #2c3e50a2;
  transition: .5s;
}

.padding {
  padding-top: 32px;
}
h1 {
  font-family: "Cinzel", serif;
}

body {
  font-size: 0.875rem;
}

.feather {
  margin-top: 5px;
  width: 20px;
  height: 20px;
  vertical-align: text-bottom;
}
.logo {
  position: absolute;
  left: 5rem;
}

.card-top {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 20px 10px 10px 10px;
  color: rgba(0, 0, 0, 0.525);
  border-radius: 10px;
  margin-top: 15px;
}

/*
 * Sidebar
 */

.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 999; /* Behind the navbar */
  padding: 0;
  width: 0px;
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.1);
  transition: 1s;
}

.sidebar a {
  padding-right: 0;
  padding-left: 5px;
}

#search-bar {
  margin-left: 0rem;
}

.mySidebar {
  width: 100px;
  transition: 1s;
}

.sidebar-sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 60px;
  height: calc(100vh);
  padding-top: 0.5rem;
  overflow-x: hidden;
  overflow-y: auto;
}

.sidebar-sticky ul {
  min-width: 100px;
}

.sidebar .nav-link {
  font-weight: 500;
  color: #333;
}

.sidebar .nav-link:hover {
  animation-name: shake;
  animation-duration: 0.5s;
  animation-iteration-count: 2;
}
.turn-gear {
  transform: rotate(0deg);
  transition: 1s;
}
.turn-gear:hover {
  transform: rotate(360deg);
  transition: 1s;
}
.hide {
  display: none;
  transition: 1s;
  margin-left: 5rem;
}

.sidebar .nav-link .feather {
  margin-right: 4px;
  color: rgb(49, 49, 49);
}

.sidebar .nav-link.active {
  color: #007bff;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
  color: inherit;
}

.sidebar-heading {
  font-size: 0.75rem;
  text-transform: uppercase;
}

/*
 * Navbar
 */
.navbar-nav {
  margin-right: 0;
  padding-right: 0 !important;
}
.navbar-brand {
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  font-size: 1rem;
  text-align: left;
  color: white;
  background-color: rgba(0, 0, 0, 0.75);
  transition: 0.5s;
  /* box-shadow: inset -1px 0 0 rgba(0, 0, 0, .25); */
}
.navbar-brand:hover {
  color: rgba(255, 255, 255, 0.5);
  transition: 0.5s;
  cursor: pointer;
}

.navbar .form-control {
  padding: 0.75rem 1rem;
  border-width: 0;
  border-radius: 0;
}

.form-control-dark {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.1);
}

.form-control-dark:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.25);
}

/*
 * Utilities
 */

.border-top {
  border-top: 1px solid #e5e5e5;
}
.border-bottom {
  border-bottom: 1px solid #e5e5e5;
}
.icon {
  width: 30px;
  height: 30px;
  position: relative;
  top: 10%;
  margin-right: 20px;
  color: rgba(0,0,0,.525);
}

.navbar {
  /* border-bottom: 1px solid rgba(0,0,0,.125); */
  background-image: linear-gradient(
    141deg,
    #2cb5e8 10%,
    #1fc8db 25%,
    #41ce8e 75%
  );
}

.padding {
  padding-top: 32px;
}

.ml-diff {
  margin-left: 0 !important;
}

.chart-container {
  position: relative;
  margin: auto;
  height: 100%;
  width: 100%;
}

#myChart {
  height: 250px !important;
}

.footer {
  padding: 20px 0px 0px 20px;
  margin: 0;
}
.footer p {
  font-size: 20px;
  color: rgba(0, 0, 0, 0.5);
}
/* .user-icon {
  border: 2px rgba(0, 0, 0, 0.525) solid;
  border-radius: 100px;
  margin-left: 15px;
  margin-top: 5px;
} */

.flex-box {
  display: flex;
}
.flex-left {
  flex: 2;
  padding-left: 10px;
}
.flex-right {
  flex: 1;
}

@media screen and (min-width: 768px) {
  .ml-diff {
    margin-left: 100px !important;
  }
  #myChart {
    height: 350px !important;
  }
  .footer {
    padding-left: 150px;
  }
  .sidebar {
    width: 100px;
    white-space: nowrap;
  }
  #search-bar {
    margin-left: 4rem;
  }
}

@keyframes shake {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes gear {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>